import ReactModal from 'react-modal';
import { EventEmitter } from 'events';
import React, { Component } from 'react';

import AppointmentForm from '../appointmentForm/appointmentFormContainer';
import { withPaymentInfoSetupStatus } from '../../../common/hoc/paymentInfoSetupStatus';
import SetupPaymentInfoModal from '../../../common/SetupPaymentInfoModal';

class AddAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      opened: false,
      populateFromAppointment: null,
    };
  }

  componentDidMount() {
    EventEmitter.prototype.on('appointment-created', this.updateProps);
    EventEmitter.prototype.on('open-appointment-modal', this.openModal);
    EventEmitter.prototype.on('close-appointment-modal', this.closeModal);
    EventEmitter.prototype.on('rebook-appointment', this.setPopulateFromAppointment);
  }

  componentWillUnmount() {
    EventEmitter.prototype.removeListener('appointment-created', this.updateProps);
    EventEmitter.prototype.removeListener('open-appointment-modal', this.openModal);
    EventEmitter.prototype.removeListener('close-appointment-modal', this.closeModal);
  }

  updateProps = (data) => {
    this.setState({ data });
  };

  setPopulateFromAppointment = ({ appointment: populateFromAppointment }) => {
    this.setState({ populateFromAppointment });
  };

  openModal = (type) => {
    if (type === 'new') {
      this.setState({
        opened: true,
      });
    }
  };

  closeModal = (type) => {
    if (type === 'new') {
      this.setState({
        opened: false,
        populateFromAppointment: null,
      });
    }
  };

  render() {
    return !this.props.isPaymentInfoSetup ? (
      <SetupPaymentInfoModal isOpen={this.state.opened} onClose={() => this.closeModal('new')} />
    ) : (
      <ReactModal
        className={{
          base: 'remodal remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        overlayClassName={{
          base: 'remodal-overlay remodal-wrapper remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        closeTimeoutMS={150}
        onRequestClose={() => this.closeModal('new')}
        contentLabel="Modal"
        shouldCloseOnOverlayClick
        isOpen={this.state.opened}
        ariaHideApp={false}
      >
        <AppointmentForm savedData={this.state.data} populateFromAppointment={this.state.populateFromAppointment} />
      </ReactModal>
    );
  }
}

export default withPaymentInfoSetupStatus(AddAppointment);
